import { Flex, Layout, Menu, Tooltip } from 'antd';
import cep from '@/pages/catalog/[...catalog_query]/CatalogExplorerPage.module.scss';
import Image from 'next/image';
import icon_filter_arrow_down from '/public/static/images/icon_filter_arrow_down.svg';
import { CatalogQueryService } from '@/utils/services/CatalogQueryService';
import CatalogCheckboxItem from '@/components/Catalog/CatalogCheckboxItem/CatalogCheckboxItem';
import React from 'react';

const CatalogFiltersBar = ({ catalogType, filterItems }: any) => (
    <Flex
        vertical
        style={{ width: '300px' }}
    >
        <Layout className={cep.body__sidebarContainer}>
            <Menu
                expandIcon={
                    <Image
                        style={{ width: '24px', height: '24px' }}
                        src={icon_filter_arrow_down}
                        width={0}
                        height={0}
                        sizes={'100%'}
                        alt={''}
                    />
                }
                className={cep.sidebar}
                mode={'inline'}
                defaultOpenKeys={CatalogQueryService.existsCategoryKeys(catalogType)}
                items={
                    filterItems
                        ?.filter((f: { values: string | any[] }) => f.values.length > 1)
                        ?.map((item: any, i: number) => ({
                            key: `${item.code}-${i}`,
                            label: item.name,
                            children: item.values.map((value: any, j: number) => ({
                                key: `${item.code}-${i}-${value.value}-${j}`,
                                label: (
                                    <CatalogCheckboxItem
                                        checked={CatalogQueryService.existsValue(
                                            catalogType,
                                            item.code,
                                            value.value,
                                        )}
                                        catalogType={catalogType}
                                        item_value={value}
                                        category_name={item.code}
                                        item_title={item.value}
                                    />
                                ),
                            })),
                        })) ?? []
                }
            />
        </Layout>
    </Flex>
);

export default CatalogFiltersBar;
